import _ from 'lodash'
import { Enums, Entities } from '@/model/util'

import { Company } from '@/model/company'

import { ApplicationModuleEnum } from '@/model/environment'

export const UserStatusEnum = Enums.create('userStatus', {
  ACTIVE: Enums.value('active', 'user.statuses.active'),
  INACTIVE: Enums.value('inactive', 'user.statuses.inactive'),
  UNVERIFIED: Enums.value('unverified', 'user.statuses.unverified')
})

export const UserCredentialTypeEnum = Enums.create('userCredentialType', {
  PASSWORD: Enums.value('password'),
  API_KEY: Enums.value('api-key')
})

export const Permissions = {
  LOGIN: 'login',
  CRUD_USER: 'crud-user',
  CRUD_COMPANY: 'crud-company',
  CRUD_SALES_POINT: 'crud-sales-point',
  WRITE_APP_ACCOUNT: 'write-app-account',
  READ_APP_ACCOUNT: 'read-app-account',
  CRUD_API_KEY: 'crud-api-key'
}

export const UserRoleEnum = Enums.create('role')

export class User {
  static read = {
    id: undefined,
    role: undefined,
    email: undefined,
    permissions: undefined,
    phone_number: undefined
  }

  static update = {
    first_name: undefined,
    last_name: undefined,
    locale: undefined
  }

  constructor (data) {
    Object.assign(this, User.read, User.update, data)
    this.status = Enums.apply(this.status, UserStatusEnum)
    this.company = this.company && new Company(this.company)
  }

  get badge () {
    return this.display_name.substring(0, 2).toUpperCase()
  }

  get language () {
    const parts = this.locale && this.locale.split('-')
    return parts && parts[0]
  }

  get needsVerification () {
    return Entities.areEquals(this.status, UserStatusEnum.values.UNVERIFIED)
  }

  get fullDisplayName () {
    return `${this.display_name} (${this.email})`
  }

  hasPermission (permission) {
    return !_.isUndefined(_.find(this.permissions, p => p === permission))
  }

  hasAnyPermission (permissions) {
    return _.isEmpty(permissions) || _.some(permissions, p => this.hasPermission(p))
  }

  asUpdate () {
    return _.pick(this, _.keys(User.update))
  }

  asCreate () {
    const result = this.asUpdate()
    result.phone_number = this.phone_number
    result.email = this.email
    Entities.addReference(result, this, 'company')
    return result
  }
}

export class UserCredential {
  constructor (data) {
    Object.assign(this, data)
    this.type = Enums.apply(this.type, UserCredentialTypeEnum)
  }

  static ofReset (correlationId, password) {
    return new UserCredential({ id: correlationId, password: password })
  }

  asUpdate () {
    return { password: this.password }
  }
}

export class OAuthAuthorization {
  constructor (data) {
    this.correlation_id = undefined
    this.client = undefined
    this.url = undefined

    Object.assign(this, data)
  }
}

export class ModuleCapability {
  constructor (data) {
    Object.assign(this, data, _.find(ApplicationModuleEnum.values, m => m.id === data.module.id))
  }
}
export class UserCapabilities {
  constructor (data) {
    Object.assign(this, data)
    this.modules = _.map(data.modules, m => new ModuleCapability(m))
  }
}
